import { render } from "./PricingSection.vue?vue&type=template&id=6cdcce4d&scoped=true"
import script from "./PricingSection.vue?vue&type=script&lang=js"
export * from "./PricingSection.vue?vue&type=script&lang=js"

import "./PricingSection.vue?vue&type=style&index=0&id=6cdcce4d&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_269ca4a85a7eca3d5d7c9cc630d4bd5a/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6cdcce4d"]])

export default __exports__